import * as React from "react";
function SvgMedia(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" height={32} rx={6} width={32} />
      <path
        d="M21.85 7.28A10.5 10.5 0 1026.5 16v-.49h-.35l-.75.83-.58 1.87-1.4-2.49L21 14.67l-.68-.47h-.42l-1.09-.75.75 1h.75l.67.42-.31.83-2.25.89-.25-.59L17 14.24l-.89-.63 1.56 2.5.83.89.75-.16.47.16-.26 1-1.82 2-1.15 4.74-.75.75-.75.1-.36-.51-1.19-2.56-.21-2-.68-.89v-1l-.89-.42-1.55.36L9 17.73l-.42-.84v-1l1.93-2.57 2.49-.6v.42l.94.36.35-.42 1.2.27 1-.21.22-.89-.86.12-.62-.21v-.37l.57-.75.51-.21.52.21.57-.21-.75-.52.16-.31-.67.23.21.21-.36.11-.26-.37-.42.67.07.3-.75.1V12l-.35-.31-.28-.32V11h-.32l-.36-.42h-.16l.21.42.37.26-.05.57-.21-.47-.55-.36-.37.21h-.31l-.23.29-.26.21-.37.75h-.9l.26-1h.75l.31-.57v-.15h-.31l.46-.24v-.4l.26.16.58-.75.36-.16-.06-.21.11-.14v-.06l-.06.36h.16l.05-.05.13.05.21-.16.54-.14v-.26l.21-.11.06-.18.52-.31-.63.21-.1-.06v-.17l.26-.37h-.26l-.13.18-.17.31-.1.68-.32.31-.1-.57-.18.27v.06L13 9v-.39l.44-.2.31-.41.43-.42 1-.42h.62l.88.16v.1H16l.13.11v.1h.52l.1-.21H17v-.26H17.42l.42-.16.08.16.26-.11.06.06v.27l.47-.11.75.26-.36-.26v-.16l.36-.05.21.36.16.21-.16.21H20l.1-.16-.26-.31L21 7.21l.62.11zM16 28a12 12 0 118.49-3.51A12 12 0 0116 28zm3-16.5l-.31-.33.32-.16-.22-.26h-.26l-.22.21-.05-.11v.45l.32.36.1.52.47.31h.22l.05-.21-.32-.42-.05-.36z"
        fill="#fff"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgMedia);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
